import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { KeyRound, Lock } from "lucide-react";
import { toast } from "sonner";
import { api, setAdminCode } from "@/lib/api";
import { HOME } from "@/constants/testIds";

export default function OwnerAccessModal({ open, onOpenChange }) {
  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/admin/login", { code });
      setAdminCode(code);
      toast.success("Welcome back, Ky!");
      onOpenChange(false);
      navigate("/admin");
    } catch (err) {
      toast.error("Invalid access code");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md rounded-3xl border-amber-100">
        <DialogHeader>
          <div className="mx-auto mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-amber-50">
            <Lock className="h-5 w-5 text-amber-500" />
          </div>
          <DialogTitle className="text-center font-serif-display text-3xl">Owner Access</DialogTitle>
          <DialogDescription className="text-center">
            Enter your private access code to manage bookings, menu, and business settings.
            <span className="mt-2 block text-xs text-stone-400">Hint: your code is <span className="font-mono text-stone-500">Cake3000</span></span>
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4 pt-2">
          <div className="relative">
            <KeyRound className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-stone-400" />
            <Input
              data-testid={HOME.accessCodeInput}
              type="password"
              placeholder="Access code"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              className="pl-9 rounded-full h-11 border-stone-200 focus-visible:ring-blue-300"
              autoFocus
            />
          </div>
          <Button
            data-testid={HOME.accessCodeSubmit}
            type="submit"
            disabled={loading || !code}
            className="w-full h-11 rounded-full bg-blue-900 hover:bg-blue-800 text-white"
          >
            {loading ? "Verifying..." : "Unlock Admin Panel"}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
